import React from "react"
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaMedium,
  FaLinkedin,
  FaExternalLinkAlt,
  FaDiscord,
} from "react-icons/fa"

type SocialMediaService =
  | "facebook"
  | "twitter"
  | "instagram"
  | "medium"
  | "linkedin"
  | "discord"
  | "other"

interface SocialMediaIconProps {
  service?: SocialMediaService
  url?: string
}

const socialMediaIcons = {
  facebook: FaFacebook,
  twitter: FaTwitter,
  instagram: FaInstagram,
  medium: FaMedium,
  linkedin: FaLinkedin,
  discord: FaDiscord,
  other: FaExternalLinkAlt,
}

export const getServiceByUrl = (url: string): SocialMediaService => {
  if (url.includes("facebook.")) return "facebook"
  if (url.includes("twitter.")) return "twitter"
  if (url.includes("instagram.")) return "instagram"
  if (url.includes("medium.")) return "medium"
  if (url.includes("linkedin.")) return "linkedin"
  if (url.includes("discord.")) return "discord"

  return "other"
}

export function SocialMediaIcon({ url = "", service }: SocialMediaIconProps) {
  const socialService = service || getServiceByUrl(url)
  const Icon = socialMediaIcons[socialService] || socialMediaIcons.other

  return <Icon color="white" />
}
